import { html, LitElement, TemplateResult } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreRadio } from "@slhuicore/radio";
import { IconDefaultType as IconType } from "@slhuiicon/icon";

import { style } from "./assets/radio.generated-style";

/**
 * The slh-radio component is a simple radio button.
 * When combined with the slh-radio-group component you can provide groupable functionality to allow users to select from a predefined set of options.
 *
 * @CustomElement slh-radio
 *
 * @cssprop --slh-default-font-family - Font family
 * @cssprop --slh-color-neutral-shade-40 - Radio color
 * @cssprop --slh-color-neutral-shade-60 - Hover radio color
 * @cssprop --slh-color-neutral-shade-80 - Radio drop shadow color
 * @cssprop --slh-color-primary - Checked radio color
 * @cssprop --slh-color-primary-darken - Checked and hovered radio color
 * @cssprop --slh-color-neutral-shade-20 - Disabled and readonly radio color
 * @cssprop --slh-color-error - Error state color, error unselected hover color.
 * @cssprop --slh-color-error-darken - Hover error state color.
 * @cssprop --slh-color-error-shade-60 - Error state unselected color.
 * @cssprop --slh-color-error-shade-40 - Drop shadow color for focused error state radio.
 * @cssprop --slh-color-neutral-shade-80-opacity-12 - Unselected focused drop shadow.
 * @cssprop --slh-color-primary-shade-60 - Unselected focused drop shadow.
 *
 * ** slots
 * @slot default - Label for radio on the right side. Assigned slot nodes are parsed so that only slh-label components are shown.
 */
@customElement("slh-radio")
export default class SlhRadio extends SlhCoreRadio(LitElement) {
  static styles = style;

  /**
   * @returns {TemplateResult} render html template
   */
  renderIcon(): TemplateResult {
    return html`<slh-icon
      type="${this.checked
        ? IconType.ICO_RADIOBUTTON_SEL
        : IconType.ICO_RADIOBUTTON_DES}"
    ></slh-icon>`;
  }
}
